import { render } from "./StoryDetails.vue?vue&type=template&id=3ad17cfc&scoped=true"
import script from "./StoryDetails.vue?vue&type=script&lang=js"
export * from "./StoryDetails.vue?vue&type=script&lang=js"

import "./StoryDetails.vue?vue&type=style&index=0&id=3ad17cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad17cfc"]])

export default __exports__